import { ResourceEditor } from '@/components/admin/ResourceEditor'
import {
  CollapsibleCard,
  CollapsibleCardContent,
  CollapsibleCardFooter,
  CollapsibleCardHeader,
  CollapsibleCardTitle,
  ItemCreatedDate,
  ItemUpdatedDate,
} from '@/components/CollapsibleCard'
import { ReactNode } from 'react'

import { adminStoreActions } from '@/store/actions'
import { Resource as ResourceType } from '@/store/admin'
import { useStoreDispatch } from '@/store/hooks'
import { Button } from '@repo/ui/button'
import { useControlledOpen, useT } from '@repo/ui/hooks'
import { Trash2 } from 'lucide-react'

export function Resource({
  contentComp,
  controller,
  resource,
  titleComp,
}: {
  contentComp?: ReactNode
  controller?: {
    defaultOpen?: boolean
    onOpenChange?: (open: boolean) => void
    open?: boolean
  }
  resource: ResourceType
  titleComp?: ReactNode
}) {
  const dispatch = useStoreDispatch()
  const { tc } = useT()
  const [open, setOpen] = useControlledOpen({
    openProp: controller?.open,
    defaultOpen: controller?.defaultOpen,
    onOpenChange: controller?.onOpenChange,
  })
  return (
    <CollapsibleCard open={open} onOpenChange={() => setOpen(!open)}>
      <div className="border-primary-100 flex items-center gap-1 border-b px-3 py-1">
        <ItemCreatedDate createdAt={resource.createdAt} className="text-xs" />
        <span className="text-primary-500 font-thin">•</span>
        <ItemUpdatedDate updatedAt={resource.updatedAt} className="text-xs" />
      </div>
      <CollapsibleCardHeader>
        <CollapsibleCardTitle>
          {titleComp ? titleComp : <>{resource.title}</>}
        </CollapsibleCardTitle>
      </CollapsibleCardHeader>

      <CollapsibleCardContent>
        <div className="whitespace-pre-wrap text-pretty">
          {contentComp ? contentComp : <>{resource.content}</>}
        </div>
        <CollapsibleCardFooter>
          <Button
            isSensitive
            variant="outline"
            size="sm"
            onClick={() => {
              void dispatch(
                adminStoreActions.resource.delete({
                  resourceToDelete: resource,
                }),
              )
            }}
          >
            <Trash2 className="size-4" />
            {tc('delete', { cfl: true })}
          </Button>
          <ResourceEditor resource={resource} />
        </CollapsibleCardFooter>
      </CollapsibleCardContent>
    </CollapsibleCard>
  )
}
